<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-form ref="formCheckIn">
          <v-card class="my-4 rounded-top" outlined min-width="100%">
            <v-card-title class="py-2">{{ $t("page.sectionEditor.keytime", 1) }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" xs="12">
                  <v-switch
                    compact
                    dense
                    name="inKeyFlag"
                    v-model="Check.keyTimeFlag"
                    :input-value="Check.keyTimeFlag"
                    :label="$t('page.sectionEditor.usekeytime')"
                    @change="updateCheckField('keyTimeFlag', Check.keyTimeFlag)"
                    :true-value="1"
                    :false-value="0"
                    color="blue"
                    hide-details
                  ></v-switch>
                </v-col>
                <v-col cols="12" v-if="bModeSprint">
                  <v-row>
                    <v-col cols="12" md="8" sm="10" v-for="(keyTimeItem, i) in keyTimeDataLocal" :key="`key-${i}`" class="d-flex">
                      <v-select 
                        v-model="keyTimeItem.keyTimeNumber"
                        :items="itemsKeyTime"
                        style="max-width: 160px"
                        prepend-icon="fal fa-clock"
                        outlined dense
                        @change="updateCheckField('keyTimeNumber', keyTimeItem)"
                        :rules="[ (v) => $inputRules({ value: v }, 'filled') || $t('page.sectionEditor.keytime-number-required') ]"
                        :no-data-text="$t('common.no_data')"
                      ></v-select>
                      <DateTimeText 
                        ref="dateTimeText"
                        :label="$t('page.sectionEditor.keytime')"
                        :time="keyTimeItem"
                        @updateField="updateFieldCheck"
                      />
                      <v-btn text @click="deleteKeyTime(keyTimeItem, i)">
                        <i class="fas fa-trash mr-1"></i>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="8" sm="10" v-if="bModeSprint" class="d-flex">
                  <v-btn class="text-rigth" small color="primary" :disabled="disabledAddKeyTime" @click="addItemKeyTime">
                    <i class="fas fa-plus mr-1"></i> {{ $t('page.sectionEditor.add_key_time', 1) }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6" sm="6" v-if="!bModeSprint">
                  <DateTimeText 
                      :label="$t('page.sectionEditor.keytime')"
                      :time="Check"
                      @updateField="updateFieldCheck"
                  />
                </v-col>
                <v-col cols="auto" md="6" sm="6" v-if="!bModeSprint">
                  <v-text-field
                    outlined
                    dense
                    :label="$t('page.sectionEditor.adjustsec')"
                    name="inAdjustment"
                    v-model="Check.adjustment"                  
                    :hint="$t('page.sectionEditor.racalculated_info')"
                    persistent-hint
                    @input="updateCheckField('adjustment', Check.adjustment)"
                    :rules="formatInvalidRules"
                    onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="my-4 rounded-top" outlined min-width="100%">
            <v-card-title class="py-2">{{ $t("page.sectionEditor.early_penalties", 1) }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" xs="12">
                  <v-switch
                    name="inReaderFlag"
                    dense
                    v-model="Check.inReaderFlag"
                    :input-value="Check.inReaderFlag"
                    :label="$t('page.sectionEditor.useantenna')"
                    @change="updateCheckField('inReaderFlag', Check.inReaderFlag)"
                    :true-value="1"
                    :false-value="0"
                    color="blue"
                    hide-details
                    onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                  ></v-switch>
                </v-col>

                <v-col cols="auto" sm="6">
                  <v-text-field
                    outlined
                    :label="$t('page.sectionEditor.first_minute')"
                    dense
                    name="inEarlyFirstMinute"
                    placeholder="0"
                    v-model="PenaltiesInEarly.firstMinute"
                    :hint="$t('page.sectionEditor.first_minute_lbl')"
                    persistent-hint
                    @input="updatePenalties('firstMinute', PenaltiesInEarly)"
                    :rules="formatInvalidRules"
                    onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                  ></v-text-field>
                </v-col>

                <v-col cols="auto" sm="6">
                  <v-text-field
                    outlined
                    :label="$t('page.sectionEditor.next_minute')"
                    dense
                    name="inEarlyNextMinute"
                    placeholder="0"
                    v-model="PenaltiesInEarly.nextMinute"
                    :hint="$t('page.sectionEditor.next_minute_lbl')"
                    persistent-hint
                    @input="updatePenalties('nextMinute', PenaltiesInEarly)"
                    :rules="formatInvalidRules"
                    onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="my-4 rounded-top" outlined min-width="100%">
            <v-card-title class="py-2">{{
              $t("page.sectionEditor.late_penalties", 1)
            }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" xs="12">
                  <v-switch
                    name="isLatePenalty"
                    dense
                    v-model="Check.isLatePenalty"
                    :input-value="Check.isLatePenalty"
                    :label="$t('page.sectionEditor.late_penalties')"
                    @change="updateCheckField('isLatePenalty', Check.isLatePenalty)"
                    :true-value="1"
                    :false-value="0"
                    color="blue"
                    hide-details
                  ></v-switch>
                </v-col>

                <v-col cols="auto" sm="6">
                  <v-text-field
                    outlined
                    :label="$t('page.sectionEditor.hour_out')"
                    dense
                    name="inLateDsqMinute"
                    placeholder="0"
                    v-model="PenaltiesInLate.dsqMinute"
                    :hint="$t('page.sectionEditor.calculated_original_keytime')"
                    @input="updatePenalties('dsqMinute', PenaltiesInLate)"
                    persistent-hint
                    :rules="formatInvalidRules"
                    onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Minus'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>
<style scoped lang="scss"></style>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import DateTimeText from './time-check/DateTimeText.vue';

export default {
  mixins: [apiCalls],
  components: { DateTimeText },
  props: ["Check", "Section", "runLimit"],
  data() {
    const objKeyTime = Object.freeze({ id: null, menu: false, time: null, keyTimeNumber: 1, keyTime: null });
    return {
      PenaltiesInEarly: [],
      PenaltiesInLate: [],
      time: null,
      menu: false,
      modal: false,
      //clock
      time2: null,
      menu2: false,
      modal2: false,
      keyTimeDataLocal: [],
      keyTimeForm: Object.assign({}, objKeyTime),
      itemsKeyTime: [],
      checkUpdated: []
    };
  },
  computed: {
    bModeSprint() {
      return this.Race && this.Race.mode == 10 && this.Race.subMode == 'sprint';
    },
    disabledAddKeyTime() {
      return !(this.keyTimeDataLocal.length < this.runLimit);
    },
    formatInvalidRules() {
      return [ 
        (v) => {
          const value = v ?? '';
          return this.$inputRules({ value }, 'filled') || this.$t('common.field-required')
        },
        (v) => {
          return this.$inputRules({ value: v }, 'nullable') || this.$inputRules({ value: v }, 'integer') || this.$t('common.fomat_invalid_only_number');
        } 
      ];
    },
    Race() {
      return this.$store.getters.getRaceSections;
    }
  },
  methods: {
    setPenalties: function () {
      let app = this;
      app.setInPenalties();
    },
    setInPenalties: function () {
      let app = this;
      let check = app.Check;
      check.penalties.map(function (penalty) {
        if (penalty.penaltyType == "early") {
          app.PenaltiesInEarly = penalty;
        } else {
          app.PenaltiesInLate = penalty;
        }
      });
    },
    validateTime(time) {
      const timeReg = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
      return timeReg.test(time);
    },
    updatePenalties(field, penalty) {
      if (!this.validateTime(this.Check.keyTime)) return false;
      if (penalty[field] == "") return false;

      let formData = {
        sectionId: this.Section.id,
        checkId: this.Check.id,
        penaltyId: penalty.id,
        field,
        value: penalty[field]
      };
      this.$store.dispatch('addSectionCheckPenaltiesUpdateAction',formData);
    }, 
    updateCheckField(field, value) {
      if(!this.bModeSprint) {
        if (!this.validateTime(this.Check.keyTime)) return false;
        if ((value || "").length == 0 && value != 0) return false;
      } else {
        if (field == 'keyTime' && !this.validateTime(value.keyTime)) return false;
        if (typeof value != 'object' && (value || "").length == 0 && value != 0) return false;
      }
      
      let valueReal = value;
      if(field == 'keyTime' || field == 'keyTimeNumber') {
        valueReal = this.findKeyTime(value,field);
      }
      let formData = {
        sectionId: this.Section.id,
        checkId: this.Check.id,
        field, 
        value: valueReal
      };
      if(!this.bModeSprint) {
        this.$store.dispatch('addSectionChecksInOutUpdateAction',formData);
      } else {
        if(field == 'keyTime' || field == 'keyTimeNumber') {
          formData.field = 'keyTimes';
          formData.value = this.keyTimeDataLocal;
          this.$store.dispatch('addSectionChecksInOutUpdateAction',formData);
        } else {
          this.$store.dispatch('addSectionChecksInOutUpdateAction',formData);
        }
      }
    },
    findKeyTime(value,field = 'keyTime') {
        if(typeof value == 'object') {
          if(Object.prototype.hasOwnProperty.call(value,field)) {
            value = value[field];
            return value;
          } else {
            for (const property in value) {
              if(this.findKeyTime(value[property],field)) {
                value = this.findKeyTime(value[property],field);
                return value;
              }
            }
          }
        }
        return false;
    },
    addItemKeyTime() {
      if(this.keyTimeForm.keyTimeNumber && this.keyTimeDataLocal.length > 0) {
        this.keyTimeForm.keyTimeNumber++;
      }
      this.keyTimeDataLocal.push(Object.assign({}, this.keyTimeForm));
    },
    setKeyTime: function() {
      let app = this;
      let check = app.Check;
      const arraySort = check.keyTimes.sort((a,b) => {
        if(a.keyTimeNumber > b.keyTimeNumber) return 1;
        if(a.keyTimeNumber < b.keyTimeNumber) return -1;
        return 0;
      });
      this.keyTimeDataLocal = arraySort;
      this.keytimeDataModel = this.keyTimeDataLocal.map((item) => {
        return item.keyTime;
      });
    },
    getItemsKeyTime() {
      let arrayInteger = [];
        for(let i = 1; i <= this.runLimit; i++) {
          arrayInteger.push(i);
        }
        this.itemsKeyTime = arrayInteger;
    },
    async deleteKeyTime(keyTimeItem, index = -1) {
      if(index > -1) {
          this.keyTimeDataLocal.splice(index, 1);
          this.$store.dispatch('addSectionChecksInOutUpdateAction', {
            sectionId: this.Section.id,
            checkId: this.Check.id,
            field: 'keyTimes', 
            value: this.keyTimeDataLocal
          });
      }
    },
    updateFieldCheck({ item }) {
      this.updateCheckField('keyTime', item);
    },
    updateItemsKeyTime() {
      let index = this.runLimit;
      if(index >= 0 && index < this.keyTimeDataLocal.length) {
        let deleteCount = this.keyTimeDataLocal.length - index;
        this.keyTimeDataLocal.splice(index,deleteCount);
        this.$store.dispatch('addSectionChecksInOutUpdateAction', {
            sectionId: this.Section.id,
            checkId: this.Check.id,
            field: 'keyTimes', 
            value: this.keyTimeDataLocal
        });
      }
    }
  },
  created: function () {
    this.setPenalties();
    if(this.bModeSprint) {
      this.setKeyTime();
      this.updateItemsKeyTime();
    }
  },
  mounted() {
    this.getItemsKeyTime();
  }, 
  watch: {
    runLimit() {
      if(this.bModeSprint) {
        this.getItemsKeyTime();
        this.updateItemsKeyTime();
      }
    }
  }
};
</script>

<style>
.pull-down {
  margin-top: -50px !important;
}
.pull-down-2 {
  margin-top: -25px !important;
}
</style>
